import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const UserService = {
  // Get current organization data
  getList: async () => {
    const response = await apiService.get("/organization/me");
    return response.data;
  },

  // Update KOT Bot setting
  updateKotBot: async (organizationId, usesKotBot) => {
    const response = await apiService.put(
      `/organization/${organizationId}/uses-kotbot`,
      usesKotBot,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  },

  // Update KOT Bot setting
  updateSection: async (organizationId, usesSection) => {
    const response = await apiService.put(
      `/organization/${organizationId}/should-show-section`,
      usesSection,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  },

  // Update Take Away setting
  updateTakeAway: async (organizationId, usesTakeAway) => {
    const response = await apiService.put(
      `/organization/${organizationId}/enable-takeaway`,
      usesTakeAway,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  },

  // Update organization logo
  updateLogo: async (organizationId, file) => {
    const formData = new FormData();
    formData.append("logoIamge", file);

    const response = await apiService.put(
      `/organization/${organizationId}/update-logo`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response.data;
  },

  // Update organization details (name, address, email, etc.)
  updateOrganization: async (organizationId, data) => {
    const response = await apiService.put(
      `/organization/${organizationId}`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return response.data;
  },
};

export default UserService;
